let request = require('../../../../shared/Request');
let room = require('room');
let user = require('user');

class StudentHeaderModel {
  constructor() {
    this.accountMenuVisible = false; // Whether the account menu is currently visible.
    this.mobileMenuVisible = false; // Whether the mobile account menu is currently visible.
  }

  handraiseClicked(value, callback) {
    request.post({
      url: `${window.APP_CONFIG.BACKEND_HOST}/students/api/handraise/`,
      data: {
        active: value,
        id: user.get('id'),
        room_name: room.get('name'),
      },
      success: () => {
        user.setStudentHandraise(value);

        if (callback) {
          callback();
        }
      },
      error: (response) => {
        console.error(response);
      },
    });
  }
}

module.exports = new StudentHeaderModel();
